import { GET_EXPENSE_ADJUSTMENT } from '../graphql/expenseAdjustmentQueries';
import { IExpenseAdjustment, IPayout } from '@medely/types';
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { useLegacyGraphQLRequest } from './useGraphQLRequest';

type IUseExpenseAdjustmentReturn = {
  expenseAdjustment: IExpenseAdjustment & { payout: IPayout };
  isLoading: boolean;
};

type UseExpenseAdjustmentProps = {
  id: number;
};

// TODO: migrate off @medely/types + useLegacyGraphQLRequest to the codegen pattern (see useMissingConditionsCg.ts)
export const useExpenseAdjustment = ({
  id,
}: UseExpenseAdjustmentProps): IUseExpenseAdjustmentReturn => {
  const { request } = useLegacyGraphQLRequest();

  const fetchExpenseAdjustment = async ({
    queryKey: [_entity, id],
  }: QueryFunctionContext<[unknown, number]>) => {
    const { expenseAdjustment } = (await request(GET_EXPENSE_ADJUSTMENT, { id })) as {
      expenseAdjustment: IExpenseAdjustment & { payout: IPayout };
    };
    return expenseAdjustment;
  };

  const { data, isLoading } = useQuery(['expenseAdjustment', id], fetchExpenseAdjustment);

  return {
    expenseAdjustment: data ?? ({} as IExpenseAdjustment & { payout: IPayout }),
    isLoading,
  };
};

export default useExpenseAdjustment;
